import { Checkbox } from "@/components/ui/Checkbox";
import type { CheckboxProps } from "@/components/ui/Checkbox";
import cn from "@/lib/cn";

type CheckboxBlockProps = Omit<CheckboxProps, "className">;

export function CheckboxBlock({ checked, ...props }: CheckboxBlockProps) {
  return (
    <div
      className={cn(
        "rounded-[12px] border px-4 py-3.5 transition-all duration-200",
        checked
          ? "border-[#EBF3FE] bg-[#EBF3FE]"
          : "border-[#E5E7EB] bg-[#F3F4F6]",
      )}
    >
      <Checkbox checked={checked} {...props} />
    </div>
  );
}
